import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { onBeforeMount, ref, watch, PropType } from 'vue';

import { AssetSourceEnum } from '@/helper/enums/music.enum';
import { getIconUrl } from '@/helper/utils/genericUtils';

import { getAssets } from '@/services/assetsService';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageComponent',
  props: {
  default: {
    type: String,
    default: '/musics/music-round.png',
  },
  assId: {
    type: Number,
    required: true,
  },
  source: {
    type: String as PropType<AssetSourceEnum>,
    required: true,
  }
},
  setup(__props) {

const props = __props;

/**
 * Composant permettant de charger une image ou celle par défaut.
 * 
 * Props:
 * -----
 * - assId: ID d'asset permettant de récupérer l'image soit en local ou via le serveur.
 * - default: URL image par défaut à charger (local).
 * - source: Enum definissant la source d'asset.
 * 
 */


watch(props, () => {
  getAsset();
});

const src = ref<string>(getIconUrl(props.default));

onBeforeMount(() => {
  getAsset();
});

async function getAsset() {
  if (props.assId !== -1) {
    const asset = await getAssets([props.assId], props.source);
    if (asset?.[0]?.data?.length > 0) {
      src.value = asset?.[0]?.data;
      return;
    }
  }
  src.value = getIconUrl(props.default);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", { src: src.value }, null, 8, _hoisted_1))
}
}

})